import { css } from 'lit'

/* Global internal component styles */
export const global = css`
    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }

    *:focus-visible:not(pu-button-icon) {
        outline-offset: 0.1875em;
        outline: 0.125em solid var(--pu-color-base-background, rgb(0,0,0,0.5));
        box-shadow: 0 0 0 0.15em var(--pu-color-base-text, rgb(255,255,255)), 0 0 0.25em 0.2em var(--pu-color-base-background, rgb(0,0,0,0.5));
    }

    @supports (color: rgb(from white r g b)) {
        *:focus-visible:not(pu-button-icon) {
            outline: 0.125em solid rgb(from var(--pu-color-base-background, rgb(0,0,0)) r g b / alpha);
            box-shadow: 0 0 0 0.15em rgb(from var(--pu-color-base-text, rgb(255,255,255)) r g b / alpha), 0 0 0.25em 0.2em rgb(from var(--pu-color-base-background, rgb(0,0,0) r g b / alpha));
        }
    }
`
